import Vue from 'vue'
import { prepareFailedResponse } from 'w3box-vue-api'

export default{
  updateSubscription: data => new Promise((resolve, reject) => {
    return Vue.http.post('/api/webpush/update', data).then(
      response => resolve(response.body),
      response => reject(prepareFailedResponse(response))
    )
  }),
  deleteSubscription: data => new Promise((resolve, reject) => {
    return Vue.http.post('/api/webpush/delete', data).then(
      response => resolve(response.body),
      response => reject(prepareFailedResponse(response))
    )
  }),
}
